import { makeAutoObservable } from 'mobx';
import { NotificationStore } from './stores/notificationStore';
import { WorkspaceStore } from './stores/workspaceStore';
import { ProjectStore } from './stores/projectStore';
import { TaskStore } from './stores/taskStore';
import { AlertNotificationStore } from './stores/alertNotificationStore';
import { UserModel } from './models/user';

export class RootStore {
  notificationStore: NotificationStore = new NotificationStore();
  workspaceStore: WorkspaceStore = new WorkspaceStore();
  projectStore: ProjectStore = new ProjectStore();
  taskStore: TaskStore = new TaskStore();
  alertNotificationStore: AlertNotificationStore = new AlertNotificationStore();

  currentUser: UserModel | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setCurrentUser(userId: string) {
    this.currentUser = this.workspaceStore.currentWorkspace?.users.find((user) => user.id === userId) || null;
  }
}

export const rootStore = new RootStore();
